export default "__VITE_ASSET__b26ad37d__"